<template>
    <div id="student-info" class="vx-card p-4">
        <!-- <div class="vx-col md:w-full flex items-center mb-5">
            <TitleScreen></TitleScreen>
        </div> -->
        <div class="vx-row">
            <div class="vx-col md:w-1/3">
                <label class="vs-input--label">{{ $t('dashboard.className') }}</label>
                <span class="text-danger text-sm">*</span>
                <vs-input class="w-full" v-model="classInfo.className" name="className" v-validate="'required'">
                </vs-input>
                <span class="text-danger text-sm">{{ errors.first('className') }}</span>
            </div>
            <div class="vx-col md:w-1/3">
                <label class="vs-input--label">{{ $t('navMenu.school') }}</label>
                <span class="text-danger text-sm">*</span>
                <v-select class="w-full" v-model="selectBranch" :options="branchOptions" :clearable="false"
                          v-validate="'required'" name="organizationBranchName" :disabled="isUpdate">
                    <span slot="no-options"> {{ $t('menuOrganization.emptyList') }} </span>
                </v-select>
                <span class="text-danger text-sm">{{ errors.first('organizationBranchName') }}</span>
            </div>
            <div class="vx-col md:w-1/3">
                <label class="vs-input--label">Loại học phí</label>
                <span class="text-danger text-sm">*</span>
                <v-select class="w-full" v-model="classInfo.tuitionType" :options="tuitionTypeOption" :clearable="false"
                          v-validate="'required'" @input="selectType" :reduce="(option) => option.value">
                </v-select>
            </div>
            <div class="vx-col md:w-1/3 w-full mt-2" v-if="this.classInfo.tuitionType === 2">
                <label class="vs-input--label required">Học phí theo lớp</label>
                <vs-input class="w-full" v-model="formattedTuitionPerClass" v-validate="'required'" type="text"
                          @input="formatInputMoney"/>
            </div>
            <div class="vx-col md:w-1/3 w-full mt-2" v-if="this.classInfo.tuitionType === 3">
                <label class="vs-input--label required">Học phí theo tiết</label>
                <vs-input class="vs-input w-full" v-model="formattedTuitionPerLesson" @input="formatInput"
                          type="text"/>
            </div>
            <div class="vx-col md:w-1/3 mt-4" v-show="isUpdate">
                <vs-checkbox class="mt-4" v-model="statusClass">{{ $t('root.active') }}</vs-checkbox>
            </div>
        </div>

        <div class="vx-row mt-4">
            <div class="vx-col md:w-full w-full">
                <label class="vs-input--label">{{ $t('invoice.note') }}</label>
                <vs-textarea v-model="classInfo.description"/>
            </div>
        </div>

        <div class="vx-col md:w-1/3 mt-4">
            <vs-checkbox class="mt-4" v-model="classInfo.isGraduated">Lớp tốt nghiệp</vs-checkbox>
        </div>

        <!-- Save & Reset Button -->
        <div class="vx-row">
            <div class="vx-col w-full">
                <div class="flex flex-wrap items-center justify-end">
                    <vs-button class="ml-auto mt-2" @click="saveChanges" :disabled="!validateForm"
                               v-if="isPermissionUpdate()">{{
                            `${isUpdate ?
                                $t('button.update') : $t('button.create')}`
                        }}
                    </vs-button>
                    <vs-button class="ml-4 mt-2" type="border" color="warning" @click="$router.go(-1)">
                        {{ $t('button.back') }}
                    </vs-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

// import TitleScreen from "../../../layouts/main/";
import vSelect from 'vue-select'
import {isRouter} from '../../../store/permission';
import {constRouter} from '../../../store/constant';

export default {
    data() {
        return {
            classInfo: {
                className: null,
                description: '',
                tuitionPerClass: null,
                tuitionPerLesson: null,
                tuitionType: null,
                isGraduated:false
            },
            branchOptions: [],
            branchId: null,
            isUpdate: false,
            statusClass: true,
            formattedTuitionPerClass: 0,
            formattedTuitionPerLesson: 0,
            tuitionTypeOption: [
                {value: 3, label: 'Học phí 1 tiết'},
                {value: 2, label: 'Học phí cả lớp'}
            ]
        }
    },

    components: {
        vSelect
    },

    async created() {
        let branchList = JSON.parse(localStorage.getItem('branchInfoList') || '[]');
        if (branchList.length === 0) {
            return this.$vs.notify({
                text: this.$t('warningMenuOrganization.emptyEmployee'),
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'danger'
            });
        }
        this.branchOptions = branchList.filter(x => x.organizationBranchType === 3).map(item => {
            return {value: item.id, label: item.organizationBranchName}
        });

        this.selectBranch = this.branchOptions[0]

        let userInfo = JSON.parse(localStorage.getItem('userInfo'))
        this.classInfo.organizationId = userInfo.organization.id

        let classId = this.$route.query.id
        if (classId) {
            this.isUpdate = true
            this.getInfoClass(classId)
        }
    },

    computed: {

        validateForm() {
            return !this.errors.any()
        },

        selectBranch: {
            get() {
                let obj = this.branchOptions.find(x => x.value == this.branchId)
                if (!obj) return
                return {
                    label: obj.label,
                    value: obj.value
                }
            },
            set(obj) {
                this.branchId = obj ? obj.value : null
            }
        }
    },

    methods: {
        selectType(selectType) {
            if (selectType === 3) {
                this.formattedTuitionPerLesson = 0
            } else if (selectType === 2) {
                this.formattedTuitionPerClass = 0
            }
        },
        removeDots(input) {
            return input.replace(/\./g, '');
        },
        formatInput(event) {
            let value = event;
            value = String(value).replace(/\D/g, '');
            if (value) {
                value = Number(value).toLocaleString('vi-VN');
            }
            this.formattedTuitionPerLesson = value;
            this.classInfo.tuitionPerLesson = this.removeDots(this.formattedTuitionPerLesson)
        },
        formatInputMoney(event) {
            let value = event;
            value = String(value).replace(/\D/g, '');
            if (value) {
                value = Number(value).toLocaleString('vi-VN');
            }
            this.formattedTuitionPerClass = value;
            this.classInfo.tuitionPerClass = this.removeDots(this.formattedTuitionPerClass)
        },
        isPermissionUpdate() {
            return isRouter(this, constRouter.class_edit)
        },
        getInfoClass(id) {
            this.$vs.loading()
            this.$crm.get(`/school-classroom/find-by-id/${id}`).then(res => {
                this.classInfo = res.data
                this.classInfo.isGraduated = (res.data.isGraduated == 1) ? true : false
                if (this.classInfo.tuitionType === 3) {
                    this.formattedTuitionPerLesson = this.classInfo.tuitionPerLesson
                    this.formatInput(this.classInfo.tuitionPerLesson)
                } else if (this.classInfo.tuitionType === 2) {
                    this.formattedTuitionPerClass = this.classInfo.tuitionPerClass
                    this.formatInputMoney(this.classInfo.tuitionPerClass)
                }
                this.branchId = res.data.organizationBranchId
                this.statusClass = res.data.status
                this.$vs.loading.close()
            }).catch(err => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            })
        },

        async saveChanges(evt) {
            evt.preventDefault();
            if (!this.validateForm) return

            const result = await this.$validator.validateAll();
            if (!result) return;
            if (!this.classInfo.tuitionPerClass) {
                this.classInfo.tuitionPerClass = null;
            }
            if (!this.classInfo.tuitionPerLesson) {
                this.classInfo.tuitionPerLesson = null;
            }
            this.classInfo.organizationBranchId = this.branchId
            this.classInfo.status = this.statusClass
            this.classInfo.isGraduated = this.classInfo.isGraduated ? 1 : 2
            this.$vs.loading()
            let url = this.isUpdate ? '/school-classroom/update' : '/school-classroom/create'
            this.$crm.post(url, this.classInfo).then(() => {
                this.$vs.notify({
                    color: 'success',
                    text: `${this.isUpdate ? this.$t('button.update') : this.$t('button.create')} lớp học thành công`,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                });
                this.$router.push('/user/manage-class')
                this.$vs.loading.close()
            }).catch(err => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            })
        }
    },
}
</script>
